// src/components/private/common_components/getPaginationItems.js
// Function to get pagination items

import React from 'react';
import { Pagination } from 'react-bootstrap';

export const getPaginationItems = (currentPage, totalPages, maxPages, handlePageChange) => {
    let items = [];
    let startPage, endPage;

    if (totalPages <= maxPages) {
        // Total pages less than max, show all pages
        startPage = 1;
        endPage = totalPages;
    } else {
        // Total pages more than max, calculate start and end pages
        const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
        const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;

        if (currentPage <= maxPagesBeforeCurrentPage) {
            // Current page near the start
            startPage = 1;
            endPage = maxPages;
        } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
            // Current page near the end
            startPage = totalPages - maxPages + 1;
            endPage = totalPages;
        } else {
            // Current page somewhere in the middle
            startPage = currentPage - maxPagesBeforeCurrentPage;
            endPage = currentPage + maxPagesAfterCurrentPage;
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        items.push(
            <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
                {i}
            </Pagination.Item>
        );
    }

    return items;
};
